export default "__VITE_ASSET__DOL8a_1y__"